import React from 'react';
import PropTypes from 'prop-types';
import { GiftIcon } from 'sharedComponents/Icons';
import { PACKAGING_TYPES, GIFT_NOTE_TYPES } from 'constants/index';
import { ProductLinkButton } from 'modules/clients/components/Product/components';

const renderOptions = ({ isGiftBox, isGiftCard, giftReceipt }, classes) => {
  if (!isGiftBox && !isGiftCard && !giftReceipt) return null;
  return (
    <div className={classes.options}>
      {isGiftBox && <span>Box</span>}
      {isGiftBox && isGiftCard && <span>+</span>}
      {isGiftCard && <span>Card</span>}
      {(isGiftBox || isGiftCard) && giftReceipt && <span>+</span>}
      {giftReceipt && <span>Gift Receipt</span>}
    </div>
  );
};

const GiftOptionsButton = ({
  classes,
  hideGiftOptions,
  giftOptions,
  isOrderWrappable,
  isProductWrappable,
  onClick,
  mainBrand,
}) => {
  const { giftCard = GIFT_NOTE_TYPES.NO_GIFT_NOTE, giftWrapCode, giftReceipt } = giftOptions || {};
  const isElevatedGiftPackaging = mainBrand === 'BG' && giftWrapCode === PACKAGING_TYPES.GIFT_PACKAGING;
  const isGiftBox = giftWrapCode === PACKAGING_TYPES.GIFT_PACKAGING || isElevatedGiftPackaging;
  const isGiftCard = giftCard !== GIFT_NOTE_TYPES.NO_GIFT_NOTE;
  const isLinkEditable = ((isGiftBox || isGiftCard) && isOrderWrappable) || giftReceipt;

  const renderGiftOptions = () =>
    !isProductWrappable ? (
      <div>Not eligible for gift wrapping</div>
    ) : (
      <>
        <GiftIcon className={isOrderWrappable ? classes.iconGreen : classes.icon} />
        {isOrderWrappable && renderOptions({ isGiftBox, isGiftCard, giftReceipt }, classes)}
        <ProductLinkButton
          onClick={onClick}
          disabled={!isOrderWrappable}
          data-testid="gift-options"
          buttonText={isLinkEditable ? 'Edit' : 'Gift options'}
        />
      </>
    );

  const renderViewOnlyOptions = () =>
    !isOrderWrappable ? null : (
      <>
        {(isGiftBox || isGiftCard || giftReceipt) && <GiftIcon className={classes.icon} />}
        {renderOptions({ isGiftBox, isGiftCard, giftReceipt }, classes)}
      </>
    );

  return <div className={classes.giftOptions}>{hideGiftOptions ? renderViewOnlyOptions() : renderGiftOptions()}</div>;
};

GiftOptionsButton.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string),
  giftOptions: PropTypes.shape({
    giftWrapCode: PropTypes.string,
    giftCard: PropTypes.string,
  }),
  hideGiftOptions: PropTypes.bool,
  isOrderWrappable: PropTypes.bool,
  isProductWrappable: PropTypes.bool,
  onClick: PropTypes.func,
  mainBrand: PropTypes.string,
};

GiftOptionsButton.defaultProps = {
  classes: {},
  giftOptions: {},
  onClick: () => {},
};

export default GiftOptionsButton;
